<template>
    <div class="card mb-g">
        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <form
                id="contract_create"
                class="form"
                @submit.prevent="handleSubmit(startUpload)"
            >
                <div class="card-body pb-0 px-4">
                    <div class="d-flex flex-row pb-3 pt-2">
                        <h5 class="mb-0 flex-1 text-dark fw-500">
                            Xác minh danh tính
                        </h5>
                    </div>

                    <div class="pb-3 pt-2 text-muted">
                        <div class="row">
                            <div v-if="checkCandidate" class="col-md-4">
                                <div class="img_profile">
                                    <img
                                        class="image_general"
                                        src="media/profile_verify.png"
                                        alt="Xác minh danh tính"
                                    >
                                </div>
                            </div>

                            <div :class="checkCandidate ? 'col-md-8' : 'col-md-12'">
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="mt-2">
                                            <label class="form-label">
                                                Họ và tên <span class="text-danger">(*)</span>
                                            </label>
                                            <ValidationProvider
                                                vid="name"
                                                name="Họ và tên"
                                                rules="required"
                                                v-slot="{ errors, classes }"
                                            >
                                                <input
                                                    v-model="user.name"
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="Họ và tên"
                                                    autocomplete="off"
                                                    :class="classes"
                                                    disabled
                                                >
                                                <div class="invalid-feedback">{{ errors[0] }}</div>
                                            </ValidationProvider>
                                        </div>

                                        <div v-if="!checkCandidate" class="mt-2">
                                            <label class="form-label">
                                                Văn phòng <span class="text-danger">(*)</span>
                                            </label>
                                            <input
                                                v-model="user.profile.branch"
                                                type="text"
                                                class="form-control"
                                                placeholder="Văn phòng"
                                                disabled
                                            >
                                        </div>

                                        <div v-if="checkCandidate || checkPassCandidate" class="mt-2">
                                            <label class="form-label">
                                                Địa chỉ <span class="text-danger">(*)</span>
                                            </label>
                                            <ValidationProvider
                                                vid="address"
                                                name="Địa chỉ"
                                                rules="required"
                                                v-slot="{ errors, classes }"
                                            >
                                                <input
                                                    v-model="user.profile.address"
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="Nhập địa chỉ thường trú"
                                                    :class="classes"
                                                >
                                                <div class="invalid-feedback">{{ errors[0] }}</div>
                                            </ValidationProvider>
                                        </div>
                                    </div>

                                    <div class="col-md-4">
                                        <div v-if="!checkCandidate" class="mt-2">
                                            <label class="form-label">
                                                Số điện thoại <span class="text-danger">(*)</span>
                                            </label>
                                            <input
                                                v-model="user.profile.phone"
                                                type="text"
                                                class="form-control"
                                                placeholder="Số điện thoại"
                                                disabled
                                            >
                                        </div>

                                        <div v-if="checkCandidate || checkPassCandidate" class="mt-2">
                                            <label class="form-label">
                                                Giới tính <span class="text-danger">(*)</span>
                                            </label>
                                            <ValidationProvider
                                                vid="profile_gender"
                                                name="Giới tính"
                                                rules="required"
                                                v-slot="{ errors, classes }"
                                            >
                                                <edutalk-select
                                                    v-model="user.profile.gender"
                                                    class="w-100"
                                                    placeholder="Chọn giới tính"
                                                    :class="classes"
                                                >
                                                    <edutalk-option
                                                        v-for="item in genderOptions"
                                                        :key="item.id"
                                                        :label="item.name"
                                                        :value="item.name"
                                                    />
                                                </edutalk-select>
                                                <div class="invalid-feedback">{{ errors[0] }}</div>
                                            </ValidationProvider>
                                        </div>

                                        <div v-if="checkPassCandidate" class="mt-2">
                                            <label class="form-label">
                                                Cơ chế lương <span class="text-danger">(*)</span>
                                            </label>
                                            <ValidationProvider
                                                vid="salary_mechanism_id"
                                                name="Cơ chế lương"
                                                rules="required"
                                                v-slot="{ errors, classes }"
                                            >
                                                <edutalk-select
                                                    v-model="user.profile.salary_mechanism_id"
                                                    class="w-100"
                                                    placeholder="Chọn cơ chế lương"
                                                    :class="classes"
                                                >
                                                    <edutalk-option
                                                        v-for="item in mechanisms"
                                                        :key="item.id"
                                                        :label="item.name"
                                                        :value="item.id"
                                                    />
                                                </edutalk-select>
                                                <div class="invalid-feedback">{{ errors[0] }}</div>
                                            </ValidationProvider>
                                        </div>
                                    </div>

                                    <div class="col-md-4">
                                        <div v-if="!checkCandidate" class="mt-2">
                                            <label class="form-label">
                                                Khu vực <span class="text-danger">(*)</span>
                                            </label>
                                            <input
                                                v-model="user.profile.area"
                                                type="text"
                                                class="form-control"
                                                placeholder="Khu vực"
                                                disabled
                                            >
                                        </div>

                                        <div v-if="checkCandidate || checkPassCandidate" class="mt-2">
                                            <label class="form-label">
                                                Ngày sinh <span class="text-danger">(*)</span>
                                            </label>
                                            <ValidationProvider
                                                vid="profile_birthday"
                                                name="Ngày sinh"
                                                rules="required"
                                                v-slot="{ errors, classes }"
                                            >
                                                <el-date-picker
                                                    v-model="user.profile.birthday"
                                                    class="w-100"
                                                    type="date"
                                                    format="dd-MM-yyyy"
                                                    value-format="dd-MM-yyyy"
                                                    placeholder="Ngày sinh"
                                                    :picker-options="birthdayPickerOptions"
                                                    :class="classes"
                                                />
                                                <div class="invalid-feedback">{{ errors[0] }}</div>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="!checkCandidate" class="mt-4">
                                    <h3 class="font-weight-bold">Thông tin tài khoản nội bộ</h3>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <label class="form-label">
                                                Email đăng nhập <span class="text-danger">(*)</span>
                                            </label>
                                            <input
                                                v-model="user.email"
                                                type="text"
                                                class="form-control"
                                                placeholder="Email đăng nhập"
                                                disabled
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <template v-if="verifying">
                            <div class="identity-detail-section">
                                <div class="section-heading">
                                    <h5 class="mb-1">Tải lên thẻ căn cước và ảnh cá nhân</h5>
                                    <p class="mb-0 text-muted">
                                        Vui lòng tải lên giấy tờ và kiểm tra thông tin được trích xuấtsadasdasda.
                                    </p>
                                </div>

                                <div class="row mt-3">
                                    <div
                                        v-for="item in uploadItems"
                                        :key="item.key"
                                        class="col-lg-4 col-md-6 mb-3"
                                    >
                                        <div class="identity-upload-card">
                                            <el-upload
                                                action=""
                                                accept="image/jpeg,image/png"
                                                list-type="picture-card"
                                                :auto-upload="false"
                                                :limit="1"
                                                :file-list="identityImages[item.key]"
                                                :class="[
                          'identity-upload',
                          { 'has-file': identityImages[item.key].length }
                        ]"
                                                :on-change="(file, fileList) => handleIdentityImageChange(item.key, file, fileList)"
                                                :on-remove="() => handleIdentityImageRemove(item.key)"
                                                :on-preview="handlePictureCardPreview"
                                            >
                                                <div class="upload-placeholder">
                                                    <i :class="item.icon" />
                                                    <strong>{{ item.title }}</strong>
                                                    <small>{{ item.description }}</small>
                                                </div>
                                            </el-upload>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mt-2">
                                    <div class="col-lg-12">
                                        <div class="identity-info-box">
                                            <h6 class="identity-info-title">
                                                <i class="el-icon-postcard" /> Thông tin mặt trước
                                            </h6>

                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="form-group mt-2">
                                                        <label class="form-label">
                                                            Họ và tên <span class="text-danger">(*)</span>
                                                        </label>
                                                        <ValidationProvider
                                                            vid="cccd_full_name"
                                                            name="Họ và tên trên CCCD"
                                                            rules="required"
                                                            v-slot="{ errors, classes }"
                                                        >
                                                            <input
                                                                v-model="infoCccd.full_name"
                                                                type="text"
                                                                class="form-control"
                                                                placeholder="Nhập họ và tên"
                                                                :class="classes"
                                                            >
                                                            <div class="invalid-feedback">{{ errors[0] }}</div>
                                                        </ValidationProvider>
                                                    </div>
                                                </div>

                                                <div class="col-md-6">
                                                    <div class="form-group mt-2">
                                                        <label class="form-label">
                                                            Số CCCD <span class="text-danger">(*)</span>
                                                        </label>
                                                        <ValidationProvider
                                                            vid="cccd_id_number"
                                                            name="Số CCCD"
                                                            rules="required"
                                                            v-slot="{ errors, classes }"
                                                        >
                                                            <input
                                                                v-model.trim="infoCccd.id_number"
                                                                type="text"
                                                                maxlength="12"
                                                                class="form-control"
                                                                placeholder="Nhập số CCCD"
                                                                :class="classes"
                                                                @input="infoCccd.id_number = onlyNumber(infoCccd.id_number)"
                                                            >
                                                            <div class="invalid-feedback">{{ errors[0] }}</div>
                                                        </ValidationProvider>
                                                    </div>
                                                </div>

                                                <div class="col-md-6">
                                                    <div class="form-group mt-2">
                                                        <label class="form-label">
                                                            Ngày sinh <span class="text-danger">(*)</span>
                                                        </label>
                                                        <ValidationProvider
                                                            vid="cccd_date_of_birth"
                                                            name="Ngày sinh trên CCCD"
                                                            rules="required"
                                                            v-slot="{ errors, classes }"
                                                        >
                                                            <el-date-picker
                                                                v-model="infoCccd.date_of_birth"
                                                                class="w-100"
                                                                type="date"
                                                                format="dd-MM-yyyy"
                                                                value-format="dd-MM-yyyy"
                                                                placeholder="Chọn ngày sinh"
                                                                :picker-options="birthdayPickerOptions"
                                                                :class="classes"
                                                            />
                                                            <div class="invalid-feedback">{{ errors[0] }}</div>
                                                        </ValidationProvider>
                                                    </div>
                                                </div>

                                                <div class="col-md-6">
                                                    <div class="form-group mt-2">
                                                        <label class="form-label">
                                                            Giới tính <span class="text-danger">(*)</span>
                                                        </label>
                                                        <ValidationProvider
                                                            vid="cccd_gender"
                                                            name="Giới tính trên CCCD"
                                                            rules="required"
                                                            v-slot="{ errors, classes }"
                                                        >
                                                            <edutalk-select
                                                                v-model="infoCccd.gender"
                                                                class="w-100"
                                                                placeholder="Chọn giới tính"
                                                                :class="classes"
                                                            >
                                                                <edutalk-option
                                                                    v-for="item in genderOptions"
                                                                    :key="item.id"
                                                                    :label="item.name"
                                                                    :value="item.name"
                                                                />
                                                            </edutalk-select>
                                                            <div class="invalid-feedback">{{ errors[0] }}</div>
                                                        </ValidationProvider>
                                                    </div>
                                                </div>

                                                <div class="col-md-6">
                                                    <div class="form-group mt-2">
                                                        <label class="form-label">
                                                            Quốc tịch <span class="text-danger">(*)</span>
                                                        </label>
                                                        <ValidationProvider
                                                            vid="cccd_nationality"
                                                            name="Quốc tịch"
                                                            rules="required"
                                                            v-slot="{ errors, classes }"
                                                        >
                                                            <input
                                                                v-model.trim="infoCccd.nationality"
                                                                type="text"
                                                                class="form-control"
                                                                placeholder="Nhập quốc tịch"
                                                                :class="classes"
                                                            >
                                                            <div class="invalid-feedback">{{ errors[0] }}</div>
                                                        </ValidationProvider>
                                                    </div>
                                                </div>

                                                <div class="col-md-6">
                                                    <div class="form-group mt-2">
                                                        <label class="form-label">
                                                            Có giá trị đến ngày <span class="text-danger">(*)</span>
                                                        </label>
                                                        <ValidationProvider
                                                            vid="cccd_expiry_date"
                                                            name="Ngày hết hạn CCCD"
                                                            rules="required"
                                                            v-slot="{ errors, classes }"
                                                        >
                                                            <el-date-picker
                                                                v-model="infoCccd.expiry_date"
                                                                class="w-100"
                                                                type="date"
                                                                format="dd-MM-yyyy"
                                                                value-format="dd-MM-yyyy"
                                                                placeholder="Chọn ngày hết hạn"
                                                                :class="classes"
                                                            />
                                                            <div class="invalid-feedback">{{ errors[0] }}</div>
                                                        </ValidationProvider>
                                                    </div>
                                                </div>

                                                <div class="col-md-12">
                                                    <div class="form-group mt-2">
                                                        <label class="form-label">
                                                            Quê quán <span class="text-danger">(*)</span>
                                                        </label>
                                                        <ValidationProvider
                                                            vid="cccd_place_of_origin"
                                                            name="Quê quán"
                                                            rules="required"
                                                            v-slot="{ errors, classes }"
                                                        >
                                                            <input
                                                                v-model.trim="infoCccd.place_of_origin"
                                                                type="text"
                                                                class="form-control"
                                                                placeholder="Nhập quê quán"
                                                                :class="classes"
                                                            >
                                                            <div class="invalid-feedback">{{ errors[0] }}</div>
                                                        </ValidationProvider>
                                                    </div>
                                                </div>

                                                <div class="col-md-12">
                                                    <div class="form-group mt-2 mb-0">
                                                        <label class="form-label">
                                                            Nơi thường trú <span class="text-danger">(*)</span>
                                                        </label>
                                                        <ValidationProvider
                                                            vid="cccd_place_of_residence"
                                                            name="Nơi thường trú"
                                                            rules="required"
                                                            v-slot="{ errors, classes }"
                                                        >
                                                            <input
                                                                v-model.trim="infoCccd.place_of_residence"
                                                                type="text"
                                                                class="form-control"
                                                                placeholder="Nhập nơi thường trú"
                                                                :class="classes"
                                                            >
                                                            <div class="invalid-feedback">{{ errors[0] }}</div>
                                                        </ValidationProvider>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="identity-info-box mt-3">
                                            <h6 class="identity-info-title">
                                                <i class="el-icon-postcard" /> Thông tin mặt sau
                                            </h6>

                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="form-group mb-0">
                                                        <label class="form-label">
                                                            Ngày cấp <span class="text-danger">(*)</span>
                                                        </label>
                                                        <ValidationProvider
                                                            vid="cccd_issued_date"
                                                            name="Ngày cấp CCCD"
                                                            rules="required"
                                                            v-slot="{ errors, classes }"
                                                        >
                                                            <el-date-picker
                                                                v-model="infoCccd.issued_date"
                                                                class="w-100"
                                                                type="date"
                                                                format="dd-MM-yyyy"
                                                                value-format="dd-MM-yyyy"
                                                                placeholder="Chọn ngày cấp"
                                                                :picker-options="birthdayPickerOptions"
                                                                :class="classes"
                                                            />
                                                            <div class="invalid-feedback">{{ errors[0] }}</div>
                                                        </ValidationProvider>
                                                    </div>
                                                </div>

                                                <div class="col-md-6">
                                                    <div class="form-group mb-0">
                                                        <label class="form-label">
                                                            Cơ quan cấp <span class="text-danger">(*)</span>
                                                        </label>
                                                        <ValidationProvider
                                                            vid="cccd_issued_place"
                                                            name="Cơ quan cấp CCCD"
                                                            rules="required"
                                                            v-slot="{ errors, classes }"
                                                        >
                                                            <input
                                                                v-model.trim="infoCccd.issued_place"
                                                                type="text"
                                                                class="form-control"
                                                                placeholder="Nhập cơ quan cấp"
                                                                :class="classes"
                                                            >
                                                            <div class="invalid-feedback">{{ errors[0] }}</div>
                                                        </ValidationProvider>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

<!--                                    <div class="col-lg-4 mt-3 mt-lg-0">-->
<!--                                        <div class="identity-info-box h-100">-->
<!--                                            <h6 class="identity-info-title">-->
<!--                                                <i class="el-icon-bank-card" /> Tài khoản ngân hàng-->
<!--                                            </h6>-->

<!--                                            <div class="form-group">-->
<!--                                                <label class="form-label">Chủ tài khoản</label>-->
<!--                                                <input-->
<!--                                                    v-model.trim="infoCccd.bank_account_name"-->
<!--                                                    type="text"-->
<!--                                                    class="form-control"-->
<!--                                                    placeholder="Nhập chủ tài khoản"-->
<!--                                                >-->
<!--                                            </div>-->

<!--                                            <div class="form-group">-->
<!--                                                <label class="form-label">Ngân hàng</label>-->
<!--                                                <input-->
<!--                                                    v-model.trim="infoCccd.bank_name"-->
<!--                                                    type="text"-->
<!--                                                    class="form-control"-->
<!--                                                    placeholder="Nhập tên ngân hàng"-->
<!--                                                >-->
<!--                                            </div>-->

<!--                                            <div class="form-group mb-0">-->
<!--                                                <label class="form-label">Số tài khoản</label>-->
<!--                                                <input-->
<!--                                                    v-model.trim="infoCccd.bank_account_number"-->
<!--                                                    type="text"-->
<!--                                                    class="form-control"-->
<!--                                                    placeholder="Nhập số tài khoản"-->
<!--                                                    @input="infoCccd.bank_account_number = onlyNumber(infoCccd.bank_account_number)"-->
<!--                                                >-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
                                </div>
                            </div>
                        </template>

                        <div v-else-if="!reject" class="verifying-class mt-4">
                            <i :class="verified ? 'el-icon-success' : 'el-icon-s-promotion'" />
                            {{
                                verified
                                    ? 'Đã được xác minh danh tính'
                                    : 'Gửi thông tin xác minh danh tính thành công.'
                            }}
                        </div>

                        <div v-else class="verifying-class mt-4">
                            <i class="el-icon-warning text-warning" />
                            Thông tin xác minh của bạn bị từ chối.
                            <br>
                            Lí do: {{ user.reason }}
                            <span class="text-info reject" @click="reUpload">
                Upload lại thông tin ngay
              </span>
                        </div>
                    </div>

                    <p class="text-muted fs-xs opacity-70 text-center">
                        <i class="el-icon-info mr-2" />
                        Thông tin này chỉ được dùng để xác minh danh tính và sẽ được Edutalk giữ an toàn.
                    </p>
                </div>

                <div v-if="verifying" class="card-footer">
                    <el-button
                        native-type="submit"
                        type="success"
                        icon="el-icon-s-promotion"
                        class="float-right"
                        :disabled="!canSubmit"
                        :loading="loading"
                    >
                        Gửi thông tin xác minh
                    </el-button>
                </div>
            </form>
        </ValidationObserver>

        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="Ảnh xác minh">
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import {
    USER_PROFILE,
    USER_REQUEST_IDENTITY,
} from '@/core/services/store/profile.module';
import {
    mechanisms,
    mechanisms2,
    full_time_fixed_salary,
    part_time_fixed_salary,
    oldAreaSalesMechanism,
    oldAreaCollaboratorMechanism,
    newAreaSalesMechanism,
    newAreaCollaboratorMechanism,
    oldAreaIds,
    newAreaIds,
    getMechanismsByFacility,
} from '@/core/config/mechanism';

import {GET_SALARY_MECHANISM} from "../../../core/services/store/profile.module";

const MAX_FILE_SIZE = 2 * 1024 * 1024;
const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png'];

export default {
    name: 'EdutalkIdentity',

    data() {
        return {
            birthdayPickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },

            genderOptions: [
                { id: 1, name: 'Nam' },
                { id: 0, name: 'Nữ' },
            ],

            uploadItems: [
                {
                    key: 'front',
                    title: 'Mặt trước CCCD',
                    description: 'Ảnh rõ nét, đủ 4 góc',
                    icon: 'el-icon-postcard',
                },
                {
                    key: 'back',
                    title: 'Mặt sau CCCD',
                    description: 'Ảnh rõ nét, đủ 4 góc',
                    icon: 'el-icon-document',
                },
                {
                    key: 'portrait',
                    title: 'Ảnh chân dung',
                    description: 'Ảnh chính diện, rõ khuôn mặt',
                    icon: 'el-icon-user',
                },
            ],

            identityImages: {
                front: [],
                back: [],
                portrait: [],
            },

            infoCccd: {
                full_name: '',
                id_number: '',
                date_of_birth: '',
                gender: '',
                nationality: 'Việt Nam',
                expiry_date: '',
                place_of_origin: '',
                place_of_residence: '',
                issued_date: '',
                issued_place: '',
            },

            dialogImageUrl: '',
            dialogVisible: false,
            verifying: true,
            verified: false,
            reject: false,
            loading: false,
            mechanisms: [],
            checkCandidate: true,
            checkPassCandidate: false,

            user: {
                id: '',
                name: '',
                email: '',
                reason: '',
                profile: {
                    id: '',
                    gender: '',
                    birthday: '',
                    address: '',
                    phone: '',
                    area: '',
                    salary_mechanism_id: '',
                    branch: '',
                },
            },
        };
    },

    computed: {
        ...mapState({
            errors: state => state.auth.errors,
        }),
        ...mapGetters(['currentUser']),

        checkInfoIndentity() {
            return Boolean(
                this.user.name &&
                this.user.profile.gender &&
                this.user.profile.birthday &&
                this.user.profile.address
            );
        },

        checkInfoCccd() {
            const requiredFields = [
                'full_name',
                'id_number',
                'date_of_birth',
                'gender',
                'nationality',
                'expiry_date',
                'place_of_origin',
                'place_of_residence',
                'issued_date',
                'issued_place',
            ];

            return requiredFields.every(field => String(this.infoCccd[field] || '').trim());
        },

        hasEnoughImages() {
            return ['front', 'back', 'portrait'].every(
                key => this.identityImages[key].length === 1
            );
        },

        isAccountType29() {
            return String(this.currentUser?.profile?.account_type?.id || '') === '29';
        },

        canSubmit() {
            const validCandidate = !this.isAccountType29 || this.checkPassCandidate;
            return (
                this.hasEnoughImages &&
                this.checkInfoIndentity &&
                this.checkInfoCccd &&
                validCandidate &&
                !this.loading
            );
        },
    },

    mounted() {
        this.getProfileUser();
    },

    methods: {
        async getProfileUser() {
            try {
                const res = await this.$store.dispatch(USER_PROFILE);
                const data = res.data || {};
                const profile = data.profile || {};
                const candidateType = profile.candidate?.type;
                this.setMechanisms(profile, candidateType);
                const birthday = this.formatDate(profile.birthday);
                const address = profile.address || '';
                const gender = profile.gender || '';

                this.user = {
                    id: data.id || '',
                    name: data.name || '',
                    email: data.email || '',
                    reason: data.reason || '',
                    profile: {
                        id: profile.id || '',
                        gender,
                        birthday,
                        address,
                        area: profile.area?.name || '',
                        phone: data.phone || '',
                        salary_mechanism_id:
                            Number(profile.salary_mechanism_id) > 0
                                ? profile.salary_mechanism_id
                                : '',
                        branch: profile.branch?.name_alias || '',
                    },
                };

                this.infoCccd = {
                    ...this.infoCccd,
                    full_name: data.name || '',
                    birthday,
                    gender,
                    permanent_address: address,
                };

                if (profile.candidate) {
                    this.checkCandidate = false;
                    this.checkPassCandidate = Number(profile.candidate.status) === 3;
                }

                this.setVerifyStatus(profile.status_verify);
            } catch (error) {
                this.$notify({
                    title: 'Thất bại',
                    message: error?.data?.message || 'Không lấy được thông tin người dùng',
                    type: 'error',
                });
            }
        },

        async setMechanisms(profile, candidateType) {
            const payload = {
                area_id: profile?.khuvuc_id ?? null,
                branch_id: profile?.chi_nhanh_id ?? null,
                candidate_type: candidateType,
            };

            try {
                const res = await this.$store.dispatch(GET_SALARY_MECHANISM, payload);
                const mechanisms = res?.data ?? [];
                this.mechanisms = mechanisms;
                if (!mechanisms.length) {
                    this.$notify({
                        type: 'warning',
                        title: 'Thông báo!',
                        message: 'Khu vực này chưa có cơ chế thu nhập. Vui lòng liên hệ quản lý để được hỗ trợ.',
                    });
                }
            } catch (error) {
                this.mechanisms = [];
            }
        },

        setVerifyStatus(status) {
            const statusVerify = Number(status);

            this.verifying = statusVerify === 0;
            this.verified = statusVerify === 2 || statusVerify === 3;
            this.reject = statusVerify === 3;

            if (statusVerify === 1) {
                this.verifying = false;
                this.verified = false;
                this.reject = false;
            }
        },

        formatDate(date) {
            if (!date || date === '0000-00-00') {
                return '';
            }

            const parts = date.split('-');
            return parts.length === 3 ? parts.reverse().join('-') : date;
        },

        onlyNumber(value) {
            return String(value || '').replace(/\D/g, '');
        },

        handleIdentityImageChange(type, file, fileList) {
            const rawFile = file.raw;

            if (!rawFile) {
                this.$set(this.identityImages, type, []);
                return;
            }

            if (!ALLOWED_IMAGE_TYPES.includes(rawFile.type)) {
                this.$message.error('Chỉ được chọn ảnh JPG hoặc PNG');
                this.$set(this.identityImages, type, []);
                return;
            }

            if (rawFile.size > MAX_FILE_SIZE) {
                this.$message.error('Dung lượng mỗi ảnh không được vượt quá 2MB');
                this.$set(this.identityImages, type, []);
                return;
            }

            this.$set(this.identityImages, type, fileList.slice(-1));
        },

        handleIdentityImageRemove(type) {
            this.$set(this.identityImages, type, []);
        },

        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },

        reUpload() {
            this.verifying = true;
            this.reject = false;
            this.resetIdentityImages();
        },

        resetIdentityImages() {
            this.identityImages = {
                front: [],
                back: [],
                portrait: [],
            };
        },

        buildPayload() {
            const form = new FormData();

            form.append('file_0', this.identityImages.front[0].raw);
            form.append('file_1', this.identityImages.back[0].raw);
            form.append('file_2', this.identityImages.portrait[0].raw);

            form.append('user_id', this.user.id);
            form.append('profile_id', this.user.profile.id);
            form.append('name', this.user.name);
            form.append('gender', this.user.profile.gender || '');
            form.append('address', this.user.profile.address || '');
            form.append('birthday', this.user.profile.birthday || '');

            form.append('info_cccd', JSON.stringify(this.infoCccd));

            if (!this.checkCandidate) {
                form.append(
                    'salary_mechanism_id',
                    this.user.profile.salary_mechanism_id || ''
                );
                form.append('check_candidate', String(this.checkCandidate));
            }

            return form;
        },

        async startUpload() {
            if (!this.canSubmit) {
                this.$message.warning('Vui lòng nhập đủ thông tin và tải đủ 3 ảnh');
                return;
            }

            this.loading = true;

            try {
                const response = await this.$store.dispatch(
                    USER_REQUEST_IDENTITY,
                    this.buildPayload()
                );

                this.verifying = false;
                this.verified = false;
                this.reject = false;

                if (this.currentUser?.profile) {
                    this.currentUser.profile.status_verify = 1;
                }

                this.$message({
                    type: 'success',
                    message: response.message,
                    showClose: true,
                });
            } catch (error) {
                const validationErrors = error?.data?.data?.message_validate_form;

                if (validationErrors) {
                    this.$refs.form.setErrors(validationErrors);
                }

                this.$notify({
                    title: 'Thất bại',
                    message: error?.data?.message || 'Gửi thông tin xác minh thất bại',
                    type: 'error',
                });
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss">
.identity-detail-section {
    margin-top: 24px;
    padding-top: 24px;
    border-top: 1px solid #ebeef5;
}

.section-heading h5 {
    color: #303133;
    font-weight: 600;
}

.identity-upload-card,
.identity-info-box {
    padding: 14px;
    background: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 6px;
}

.identity-upload {
    width: 100%;
}

.identity-upload .el-upload--picture-card,
.identity-upload .el-upload-list--picture-card,
.identity-upload .el-upload-list__item {
    width: 100%;
}

.identity-upload .el-upload--picture-card,
.identity-upload .el-upload-list__item {
    height: 170px;
    margin: 0;
    border-radius: 5px;
}

.identity-upload.has-file .el-upload--picture-card {
    display: none;
}

.upload-placeholder {
    display: flex;
    height: 100%;
    padding: 20px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    line-height: 1.4;
}

.upload-placeholder i {
    margin-bottom: 12px;
    color: #409eff;
    font-size: 30px;
}

.upload-placeholder strong {
    color: #303133;
    font-size: 14px;
}

.upload-placeholder small {
    margin-top: 6px;
    color: #909399;
}

.identity-info-title {
    margin-bottom: 16px;
    padding-bottom: 10px;
    color: #303133;
    font-weight: 600;
    border-bottom: 1px solid #ebeef5;
}

.verifying-class {
    padding: 18px;
    text-align: center;
    border: 1px dashed #dcdfe6;
    border-radius: 6px;
}

.reject {
    cursor: pointer;
}

@media (max-width: 767px) {
    .identity-detail-section {
        margin-top: 16px;
        padding-top: 16px;
    }

    .identity-upload .el-upload--picture-card,
    .identity-upload .el-upload-list__item {
        height: 150px;
    }
}
</style>
